module.exports = __webpack_public_path__ + "img/loading.87356d68.gif";